import { defineMessages } from 'react-intl';

export default defineMessages({
  CONFIRM_RESOURCE_DELETION_TITLE: {
    defaultMessage: "Suppression d'une ressource",
  },

  CONFIRM_RESOURCE_DELETION_BODY: {
    defaultMessage:
      'Confirmez-vous la suppression de la ressource <b>{title}</b> ? Une fois supprimée, la ressource ne sera plus accessible {fromReference, select, true {depuis ce cours.} other {.{br}{br}<b>Cette action est irréversible.</b>}}',
  },

  DELETE_LEARNING_RESOURCE: {
    defaultMessage: 'Supprimer la ressource',
  },
} as const);
